export default __webpack_public_path__ + "static/media/property_949.798bc02e.png";